import { render, staticRenderFns } from "./BgqwPage13.vue?vue&type=template&id=19c0303a"
import script from "./BgqwPage13.vue?vue&type=script&lang=js"
export * from "./BgqwPage13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports